import http from '@/http-common'

class EmployeeEvaluationKpiService {
  getKpi(params) {
    return http.get('statistics/employee-evaluation/kpi', { params })
  }
}

export default new EmployeeEvaluationKpiService()
